import BaseClient from './BaseClient';

class MessageMediaClient extends BaseClient {
    uploadMedia(teamId, formData, config = {}) {
        const method = 'post';
        const url = `/api/v3/teams/${teamId}/upload/media`;
        const extraConfig = {
            ...config,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        return this.makeCoreApiRequest(url, method, formData, null, extraConfig);
    }
}

export default new MessageMediaClient();
